import { ApiError } from '@teko/api';

const getError = (res) => {
    return new ApiError('', 400, res);
};

export { getError };
